export type OtokocCatalogUrlEntry = {
  sku: string;
  url: string;
};

// Generated from backend/data/catalog/catalog.json; keep this file URL/SKU-only for bundle size.
export const OTOKOC_CATALOG_URL_ENTRIES = [
  { sku: '103283780', url: '/alfa-romeo/giulia/veloce' },
  { sku: '100281185', url: '/alfa-romeo/stelvio/veloce' },
  { sku: '106654359', url: '/alfa-romeo/tonale/ti' },
  { sku: '102070441', url: '/alfa-romeo/tonale/veloce' },
  { sku: '102796531', url: '/fiat/500/dolcevita' },
  { sku: '107857410', url: '/fiat/500e-e/la-prima' },
  { sku: '108155357', url: '/fiat/500e/la-prima' },
  { sku: '109260908', url: '/fiat/doblo-cargo/doblo-cargo' },
  { sku: '103940220', url: '/fiat/doblo-combi/easy' },
  { sku: '112087658', url: '/fiat/doblo-combi/premio-plus' },
  { sku: '114865160', url: '/fiat/doblo-combi/urban' },
  { sku: '105268826', url: '/fiat/ducato/city' },
  { sku: '113034811', url: '/fiat/ducato/delux' },
  { sku: '100389430', url: '/fiat/ducato/delux-school' },
  { sku: '105910717', url: '/fiat/egea-cross/cross-lounge' },
  { sku: '105104598', url: '/fiat/egea-cross/cross-street' },
  { sku: '108178723', url: '/fiat/egea-cross/cross-urban' },
  { sku: '100421057', url: '/fiat/egea/easy' },
  { sku: '104255594', url: '/fiat/egea/lounge' },
  { sku: '104853772', url: '/fiat/egea/street' },
  { sku: '105190931', url: '/fiat/egea/urban' },
  { sku: '101782816', url: '/fiat/fiorino/pop' },
  { sku: '109244490', url: '/fiat/fiorino/premio' },
  { sku: '111235851', url: '/fiat/fiorino/safeline' },
  { sku: '100566660', url: '/fiat/panda/city' },
  { sku: '111881996', url: '/fiat/panda/cross' },
  { sku: '116026415', url: '/fiat/pratico/pratico' },
  { sku: '109177685', url: '/fiat/pratico/pratico-plus' },
  { sku: '113811655', url: '/fiat/scudo/business' },
  { sku: '109351590', url: '/fiat/ulysse/lounge' },
  { sku: '100390862', url: '/ford/capri-e/premium' },
  { sku: '111137186', url: '/ford/ecosport/st-line' },
  { sku: '107145892', url: '/ford/ecosport/style' },
  { sku: '104889783', url: '/ford/explorer-e/select' },
  { sku: '104610138', url: '/ford/focus/active' },
  { sku: '114671555', url: '/ford/focus/active-stil' },
  { sku: '106975731', url: '/ford/focus/active-x' },
  { sku: '116212572', url: '/ford/focus/st-line' },
  { sku: '108349333', url: '/ford/focus/titanium' },
  { sku: '112143618', url: '/ford/focus/titanium-stil' },
  { sku: '105356990', url: '/ford/focus/titanium-x' },
  { sku: '100696635', url: '/ford/focus/trend-x' },
  { sku: '100181540', url: '/ford/kuga/st-line' },
  { sku: '100177548', url: '/ford/kuga/titanium' },
  { sku: '100618220', url: '/ford/puma-e/premium' },
  { sku: '105216848', url: '/ford/puma/st-line' },
  { sku: '101759416', url: '/ford/ranger/wildtrak' },
  { sku: '103501274', url: '/ford/tourneo-connect/active' },
  { sku: '115411496', url: '/ford/tourneo-connect/titanium' },
  { sku: '105334129', url: '/ford/tourneo-courier-journey/titanium' },
  { sku: '113958962', url: '/ford/tourneo-courier-journey/titanium-plus' },
  { sku: '100212546', url: '/ford/tourneo-courier-journey/trend' },
  { sku: '102449639', url: '/ford/tourneo-courier/colorline' },
  { sku: '114024439', url: '/ford/tourneo-courier/deluxe' },
  { sku: '115076439', url: '/ford/tourneo-courier/titanium' },
  { sku: '105537410', url: '/ford/tourneo-courier/titanium-plus' },
  { sku: '109722818', url: '/ford/tourneo-courier/trend' },
  { sku: '103482641', url: '/ford/tourneo-custom/titanium' },
  { sku: '112221338', url: '/ford/tourneo-custom/titanium-plus' },
  { sku: '108260850', url: '/ford/tourneo-custom/trend' },
  { sku: '110242086', url: '/ford/transit-connect/trend' },
  { sku: '114313505', url: '/ford/transit-courier/deluxe' },
  { sku: '102134800', url: '/ford/transit-courier/trend' },
  { sku: '115908418', url: '/ford/transit-custom/deluxe' },
  { sku: '109785821', url: '/ford/transit-custom/trend' },
  { sku: '100370805', url: '/ford/transit-e/deluxe' },
  { sku: '114442071', url: '/ford/transit-e/trend' },
  { sku: '116153657', url: '/ford/transit/deluxe' },
  { sku: '102285254', url: '/ford/transit/limited' },
  { sku: '102433396', url: '/ford/transit/trend' },
  { sku: '100517803', url: '/jeep/compass/limited' },
  { sku: '101628117', url: '/jeep/compass/longitude' },
  { sku: '113752326', url: '/jeep/compass/s-limited' },
  { sku: '107519765', url: '/jeep/renegade/limited' },
  { sku: '107148428', url: '/jeep/renegade/longitude' },
  { sku: '101250719', url: '/jeep/wrangler/rubicon' },
  { sku: '105053261', url: '/maserati/ghibli/gt' },
  { sku: '113583885', url: '/maserati/ghibli/modena-s' },
  { sku: '103747840', url: '/maserati/ghibli/trofeo' },
  { sku: '102371840', url: '/maserati/granturismo/modena' },
  { sku: '101440849', url: '/maserati/granturismo/trofeo' },
  { sku: '106528913', url: '/maserati/grecale/gt' },
  { sku: '116196906', url: '/maserati/grecale/modena' },
  { sku: '104432939', url: '/maserati/grecale/trofeo' },
  { sku: '115117406', url: '/maserati/levante/gt' },
  { sku: '102362311', url: '/maserati/levante/modena-s' },
  { sku: '112888289', url: '/maserati/levante/trofeo' },
  { sku: '116500663', url: '/maserati/mc20/mc20' },
  { sku: '107799443', url: '/maserati/quattroporte/modena' },
  { sku: '108904800', url: '/maserati/quattroporte/trofeo' },
  { sku: '101598815', url: '/volvo/ex40-e/ultra' },
  { sku: '114430160', url: '/volvo/xc60/plus-bright' },
  { sku: '109769470', url: '/volvo/xc60/plus-dark' },
  { sku: '111653662', url: '/volvo/xc90/plus-bright' },
  { sku: '100216275', url: '/volvo/xc90/plus-dark' },
  { sku: '200200002', url: 'https://www.citroen.com.tr/araclar/berlingo-van.html' },
  { sku: '200200001', url: 'https://www.citroen.com.tr/araclar/berlingo.html' },
  { sku: '200100003', url: 'https://www.citroen.com.tr/araclar/c3-aircross-suv.html' },
  { sku: '200100004', url: 'https://www.citroen.com.tr/araclar/c3-aircross-suv/ec3-aircross.html' },
  { sku: '200100002', url: 'https://www.citroen.com.tr/araclar/c3.html' },
  { sku: '200100007', url: 'https://www.citroen.com.tr/araclar/c4.html' },
  { sku: '200100008', url: 'https://www.citroen.com.tr/araclar/c4/c4-elektrik.html' },
  { sku: '200100005', url: 'https://www.citroen.com.tr/araclar/c4x.html' },
  { sku: '200100006', url: 'https://www.citroen.com.tr/araclar/c4x/e-c4x.html' },
  { sku: '200200005', url: 'https://www.citroen.com.tr/araclar/jumper.html' },
  { sku: '200200004', url: 'https://www.citroen.com.tr/araclar/jumpy-spacetourer.html' },
  { sku: '200200003', url: 'https://www.citroen.com.tr/araclar/jumpy.html' },
  { sku: '200100001', url: 'https://www.citroen.com.tr/araclar/yeni-ami.html' },
  { sku: '200100009', url: 'https://www.citroen.com.tr/araclar/yeni-c5-aircross-hibrit.html' },
  { sku: '200100010', url: 'https://www.citroen.com.tr/araclar/yeni-e-c5-aircross.html' },
  { sku: 'OPL2026006', url: 'https://www.opel.com.tr/araclar/astra/genel-bakis.html' },
  { sku: 'OPL2026007', url: 'https://www.opel.com.tr/araclar/astra/genel-bakis.html' },
  { sku: 'OPL2026001', url: 'https://www.opel.com.tr/araclar/corsa/genel-bakis.html' },
  { sku: 'OPL2026002', url: 'https://www.opel.com.tr/araclar/corsa/genel-bakis.html' },
  { sku: 'OPL2026003', url: 'https://www.opel.com.tr/araclar/frontera/genel-bakis.html' },
  { sku: 'OPL2026004', url: 'https://www.opel.com.tr/araclar/frontera/genel-bakis.html' },
  {
    sku: 'OPL2026008',
    url: 'https://www.opel.com.tr/araclar/grandland-ailesi/yeni-grandland/genel-bakis.html',
  },
  {
    sku: 'OPL2026009',
    url: 'https://www.opel.com.tr/araclar/grandland-ailesi/yeni-grandland/genel-bakis.html',
  },
  {
    sku: 'OPL2026005',
    url: 'https://www.opel.com.tr/araclar/mokka-ailesi/mokka/yeni-mokka-genel-bakis.html',
  },
  { sku: 'OPL2026013', url: 'https://www.opel.com.tr/araclar/zafira-ailesi/genel-bakis.html' },
  {
    sku: 'OPL2026014',
    url: 'https://www.opel.com.tr/araclar/zafira-ailesi/zafira-elektrik/genel-bakis.html',
  },
  {
    sku: 'OPL2026010',
    url: 'https://www.opel.com.tr/opel-ticari-araclar/combo-ailesi/combo-cargo/genel-bakis.html',
  },
  {
    sku: 'OPL2026011',
    url: 'https://www.opel.com.tr/opel-ticari-araclar/combo-ailesi/combo-cargo/genel-bakis.html',
  },
  {
    sku: 'OPL2026012',
    url: 'https://www.opel.com.tr/opel-ticari-araclar/combo-ailesi/combo-cargo/genel-bakis.html',
  },
  {
    sku: 'OPL2026017',
    url: 'https://www.opel.com.tr/opel-ticari-araclar/movano-ailesi/movano/genel-bakis.html',
  },
  {
    sku: 'OPL2026015',
    url: 'https://www.opel.com.tr/opel-ticari-araclar/vivaro-ailesi/vivaro/genel-bakis.html',
  },
  {
    sku: 'OPL2026016',
    url: 'https://www.opel.com.tr/opel-ticari-araclar/vivaro-ailesi/vivaro/genel-bakis.html',
  },
  { sku: '104520080', url: 'https://www.peugeot.com.tr/peugeot-modelleri/2008.html' },
  { sku: '104520081', url: 'https://www.peugeot.com.tr/peugeot-modelleri/2008.html' },
  { sku: '104520800', url: 'https://www.peugeot.com.tr/peugeot-modelleri/208.html' },
  { sku: '104530080', url: 'https://www.peugeot.com.tr/peugeot-modelleri/3008.html' },
  { sku: '104530081', url: 'https://www.peugeot.com.tr/peugeot-modelleri/3008.html' },
  { sku: '104530800', url: 'https://www.peugeot.com.tr/peugeot-modelleri/308.html' },
  { sku: '104540800', url: 'https://www.peugeot.com.tr/peugeot-modelleri/408.html' },
  { sku: '104550080', url: 'https://www.peugeot.com.tr/peugeot-modelleri/5008.html' },
  { sku: '104550081', url: 'https://www.peugeot.com.tr/peugeot-modelleri/5008.html' },
  { sku: '104513000', url: 'https://www.peugeot.com.tr/peugeot-modelleri/boxer.html' },
  { sku: '104513001', url: 'https://www.peugeot.com.tr/peugeot-modelleri/boxer.html' },
  { sku: '104512000', url: 'https://www.peugeot.com.tr/peugeot-modelleri/expert.html' },
  { sku: '104511000', url: 'https://www.peugeot.com.tr/peugeot-modelleri/partner.html' },
  { sku: '104560000', url: 'https://www.peugeot.com.tr/peugeot-modelleri/rifter.html' },
  { sku: '104512001', url: 'https://www.peugeot.com.tr/peugeot-modelleri/traveller.html' },
] as const satisfies readonly OtokocCatalogUrlEntry[];
